var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ContentContainer',{staticClass:"large"},[_c('PageTitle',[_vm._v("Manage Membership")]),(_vm.branch != null)?[_c('h1',[_vm._v(_vm._s(_vm.branch.TradingName))])]:_vm._e(),_c('ContentSection',[(_vm.branch != null)?[_c('PackageCheckout',{attrs:{"business":_vm.branch,"user":_vm.user}})]:_vm._e()],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }